var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cargo-advance-select-wrapper" },
    [
      !_vm.selectDisabled || _vm.multiple
        ? _c(
            "el-select",
            {
              ref: "advanceSelectRef",
              class: [_vm.canCopy ? "can-copy" : null],
              style: { position: "relative" },
              attrs: {
                "popper-class": "cargo-advance-select " + _vm.popperClass,
                "remote-method": _vm.remoteMethod,
                loading: _vm.loading,
                remote: _vm.remote,
                "filter-method": _vm.localFilterMethod,
                placeholder: _vm.placeholderText,
                clearable: _vm.clearable,
                multiple: _vm.multiple,
                filterable: _vm.remote || _vm.filterable,
                size: "mini",
                "reserve-keyword": "",
                "automatic-dropdown": _vm.automaticDropdown,
                disabled: _vm.selectDisabled,
                "default-first-option": ""
              },
              on: {
                focus: _vm.onFocus,
                blur: _vm.onBlur,
                change: _vm.onChange,
                clear: _vm.toClear,
                "visible-change": _vm.onVisibleChange
              },
              nativeOn: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.onEnter($event)
                }
              },
              model: {
                value: _vm.value,
                callback: function($$v) {
                  _vm.value = $$v
                },
                expression: "value"
              }
            },
            [
              _vm.canShowOptions.length > 0 && (_vm.remote || _vm.filterable)
                ? _c(
                    "div",
                    {
                      staticClass: "tip-count-options",
                      attrs: { value: "00000000", disabled: 1 === 1 }
                    },
                    [
                      _vm.page
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                height: "100%",
                                "padding-left": "15px",
                                "padding-top": "12px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.page
                                    ? _vm.$t("CargoMsg.Cargo_EachPage") +
                                        " " +
                                        _vm.pageSize +
                                        _vm.$t("CargoMsg.Cargo_Pcst") +
                                        ","
                                    : ""
                                ) +
                                  _vm._s(_vm.$t("Message.TotalCost1")) +
                                  _vm._s(_vm.totalCount) +
                                  _vm._s(_vm.$t("CargoMsg.Cargo_DataBar")) +
                                  " "
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticStyle: {
                                height: "100%",
                                "padding-left": "15px",
                                "padding-top": "12px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_BeforeCurrentDisplay")
                                ) +
                                  _vm._s(_vm.totalCount) +
                                  _vm._s(_vm.$t("CargoMsg.Cargo_DataBar")) +
                                  " "
                              )
                            ]
                          ),
                      _vm.page && _vm.totalCount > 0
                        ? _c("cargo-pagination", {
                            attrs: {
                              mini: "",
                              total: _vm.totalCount,
                              page: _vm.pageNum,
                              limit: _vm.pageSize
                            },
                            on: {
                              "update:page": function($event) {
                                _vm.pageNum = $event
                              },
                              "update:limit": function($event) {
                                _vm.pageSize = $event
                              },
                              pagination: _vm.getPageData
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canShowOptions.length > 0 && (_vm.remote || _vm.filterable)
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        height: "34px",
                        color: "#545557"
                      },
                      attrs: { value: "00000001" }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.Occupies")) + " ")]
                  )
                : _vm._e(),
              _vm._l(_vm.options, function(item, index) {
                return [
                  _vm.showOptions ||
                  item[_vm.ownTagValue] === _vm.defaultValue ||
                  _vm.multiple
                    ? _c(
                        "el-option",
                        {
                          key:
                            _vm.prefixNo +
                            "-" +
                            item[_vm.ownTagValue] +
                            "-" +
                            index,
                          style: _vm.getOptionStyle(item, index),
                          attrs: {
                            index: index,
                            disabled:
                              (_vm.firstHeader && index === 0) ||
                              (_vm.actionableOption &&
                                !_vm.actionableOption(item)),
                            label: _vm.getLabel(item),
                            value: item[_vm.ownTagValue]
                          }
                        },
                        [
                          (!_vm.customLabel || !_vm.showCustomLabelInOption) &&
                          !_vm.customLabelTypes.includes(_vm.selectType)
                            ? _vm._t(
                                "default",
                                [
                                  _vm.shouldUseResolvedLabelInOption()
                                    ? _c(
                                        "div",
                                        {
                                          style: {
                                            "font-size": "12px",
                                            overflow: "hidden",
                                            "text-overflow": "ellipsis",
                                            "white-space": "nowrap",
                                            "text-align": "left",
                                            padding: "0 5px",
                                            "min-width": "110px",
                                            "margin-right": "20px"
                                          },
                                          attrs: { title: _vm.getLabel(item) }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.getLabel(item)) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          style: {
                                            display: "flex",
                                            "justify-content": "space-between",
                                            "min-width": "110px",
                                            "margin-right": "20px"
                                          }
                                        },
                                        _vm._l(_vm.ownFields, function(field) {
                                          return _c(
                                            "div",
                                            {
                                              key: field,
                                              style: {
                                                flex: 1,
                                                "font-size": "12px",
                                                overflow: "hidden",
                                                "text-overflow": "ellipsis",
                                                "white-space": "nowrap",
                                                "text-align": "left",
                                                padding: "0 5px",
                                                "min-width": "70px"
                                              },
                                              attrs: {
                                                title:
                                                  item[field] ||
                                                  item[_vm.ownTagName]
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.ownFields.length > 1
                                                      ? item[field] + " " ||
                                                          item[_vm.ownTagName]
                                                      : item[_vm.ownTagName]
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                ],
                                {
                                  option: { item: item, fields: _vm.ownFields }
                                }
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _c("el-input", {
            ref: "elInput",
            class: [_vm.canCopy ? "can-copy" : null],
            attrs: {
              disabled: "",
              value: _vm.disabledLabel,
              placeholder: !_vm.disabledLabel ? _vm.placeholderText : ""
            }
          }),
      _c(
        "el-tooltip",
        { attrs: { content: _vm.$t("CargoMsg.Cargo_Copy"), placement: "top" } },
        [
          _vm.canCopy
            ? _c(
                "el-link",
                {
                  staticClass: "copy-icon",
                  class: [_vm.isFocus ? "is-focus" : ""],
                  attrs: { underline: false },
                  on: { click: _vm.handleCopy }
                },
                [_c("i", { staticClass: "el-icon-document-copy" })]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }